import { Box, Stack, keyframes, styled } from "@mui/material";
import { AskAMIBotIcon } from "Icons/Icons";
import { CUSTOM_RADII } from "Theme/Shape";

const pulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
`;

const shimmerAnimation = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const ShimmerBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(90deg, 
    ${theme.palette.grey[200]} 0%, 
    ${theme.palette.grey[100]} 50%, 
    ${theme.palette.grey[200]} 100%)`,
  backgroundSize: "1000px 100%",
  animation: `${shimmerAnimation} 2s ease-in-out infinite`,
  borderRadius: CUSTOM_RADII.chip,
  height: "16px",
  marginBottom: theme.spacing(1),
}));

export const ChatLoadingAnimation = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        py: 1,
      }}
    >
      <Box
        sx={{
          maxWidth: 650,
          width: "auto",
          padding: 1,
        }}
      >
        <Stack direction="row" sx={{ alignItems: "start" }} spacing={2}>
          <Box
            sx={{
              pt: 2,
              animation: `${pulseAnimation} 2s ease-in-out infinite`,
            }}
          >
            <AskAMIBotIcon sx={{ width: "36px", height: "36px" }} />
          </Box>
          <Box sx={{ flex: 1, pt: 2 }}>
            <Stack spacing={1}>
              {/* Shimmer lines */}
              <ShimmerBox sx={{ width: "100px", height: "8px" }} />
              <ShimmerBox sx={{ width: "90px", height: "8px" }} />
              <ShimmerBox sx={{ width: "80px", height: "8px" }} />
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
